module.exports = __webpack_public_path__ + "media/CogFuture3.14f76b4c.wav";